import React, { Component } from 'react';
import _ from 'lodash';
import configureStore, { history } from '../store/configureStore';
import { ConnectedRouter } from 'connected-react-router';
import { IntlProvider, addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import { flattenObject } from './AppUtils';
import { countryConfigUS } from '../../US/config/setup';
import { countryConfigGB } from '../../GB/config/setup';
import { countryConfigDE } from '../../DE/config/setup';
import { COUNTRY, APP_PREFIX } from './AppConstants';
import handleRoute from './handle-route';
import DataReactRoot from './DataReactRoot/DataReactRoot';
import './App.less';

addLocaleData(de);

export const getCountryConfig = (country) => {
    switch (country) {
        case COUNTRY.UNITED_STATES:
            return countryConfigUS;
        case COUNTRY.GREAT_BRITAIN:
            return countryConfigGB;
        case COUNTRY.GERMANY:
            return countryConfigDE;
        default:
            return countryConfigUS;
    }
};

export default class App extends Component {
    static defaultProps = {
        initialState: {
            serverData: {
                locale: {
                    // this will be overwritten below
                    locale: 'en-US'
                },
                messages: {}
            }
        }
    };
    static propTypes = {
        children: PropTypes.element,
        initialState: PropTypes.object
    };

    constructor(props) {
        super(props);
        const { initialState } = this.props;

        const inputLocale = _.get(initialState, 'serverData.locale.locale', 'en_US');
        const inputMessages = _.get(initialState, 'serverData.messages', []);
        this.country = _.get(initialState, 'serverData.country', '');
        this.flow = _.get(initialState, 'serverData.flow', '');
        this.clientRootRouterRedirectUrl = _.get(initialState, 'serverData.clientRootRouterRedirectUrl', false);
        this.locale = inputLocale.replace('_', '-');
        this.messages = flattenObject(inputMessages);
        this.countryConfig = getCountryConfig(this.country || 'us');

        this.store = configureStore(
            initialState,
            this.countryConfig.reducers,
            module.hot
        );
    }

    render() {
        let { children } = this.props;
        const errorPageComponent = this.countryConfig.errorPageComponent;
        const rootRoute = `${APP_PREFIX}/${this.flow}/${this.country}/`;

        if (!children) {
            children = (
                <Switch>
                    {this.countryConfig.routes().map(route => (
                        <Route key={`${route.path}`} path={route.path} exact>
                            {handleRoute(route, errorPageComponent)}
                        </Route>
                    ))}

                    {/* Add a root route handler to do a client side redirect -
                        to the URL specified in serverData.clientRootRouterRedirectUrl */}
                    {this.clientRootRouterRedirectUrl &&
                        <Route exact key={rootRoute} path={rootRoute} >
                            <Redirect from={rootRoute} to={this.clientRootRouterRedirectUrl} />
                        </Route>
                    }

                    <Route key="error-page-route" path="*">
                        {handleRoute({component: errorPageComponent}, errorPageComponent)}
                    </Route>
                </Switch>
            );
        }
        return (
            <Provider store={this.store}>
                <IntlProvider locale={this.locale} messages={this.messages}>
                    <DataReactRoot>
                        <ConnectedRouter history={history}>
                            {children}
                        </ConnectedRouter>
                    </DataReactRoot>
                </IntlProvider>
            </Provider>
        );
    }
}
